import React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import i18n from '../../i18n'
import { Link } from 'react-router-dom'
import axios from 'axios';

export default function SubscriptionNewsletter() {
  const [email, setEmail] = useState('');
  const [checked, setChecked] = useState(false);
  const { t } = useTranslation()

  const handleChange = ({target}) => {
    setEmail(target.value);
  }

  const sendSubscription = () => {
    if(email?.length === 0 || !checked) {
      return
    }
    axios.post('https://benjamiin.li/api_proxy.php/newsletter/subscribe',{email}).then(()=>{
      window.location.replace(`/${i18n.language}/newsletter-success`);
    })
  }
  return (
    <>
      <div className="mt-0 mx-auto max-w-7xl px-0 sm:px-0 lg:px-0">
        <div className="rounded-0 md:rounded-3xl bg-gray-900 py-10 px-6 sm:py-16 sm:px-12 md:flex md:p-20">
          <div className="lg:w-0 lg:flex-1 md:pe-[60px]">
          <div className='flex items-center'>
              <div className='me-3'>
                  <svg width='50px' height='50px' viewBox='0 -73.5 1171 1171' className='icon'  version='1.1' xmlns='http://www.w3.org/2000/svg'><path d='M22.454089 798.99132c13.566012 216.3545 212.378255 173.551393 212.378255 173.551394l-17.542257-368.387392S8.888077 582.63682 22.454089 798.99132zM934.651439 586.613065l21.518502 387.800823s188.988579-13.566012 188.988579-185.246232-210.507081-202.554591-210.507081-202.554591z' fill='#FFFFFF' /><path d='M867.289173 586.613065h67.362266v407.915944h-67.362266zM235.767931 586.613065h67.362265v407.915944h-67.362265z' fill='#555' /><path d='M770.222019 807.6455h-27.132024l-23.389675-23.389675a30.172682 30.172682 0 0 0-45.375971 3.508451l-21.284605 39.762449-26.898127-95.19598a29.938785 29.938785 0 0 0-27.833714-19.179534 29.938785 29.938785 0 0 0-27.833714 18.945637l-26.66423 101.043399-29.470991-46.779352a30.172682 30.172682 0 0 0-20.349018-13.566011 30.640475 30.640475 0 0 0-23.389676 6.783005l-32.043856 27.833714h-37.891274a23.389676 23.389676 0 0 0 0 46.779352h42.335313a31.108269 31.108269 0 0 0 19.413431-7.2508l22.220191-19.41343 39.528552 61.98264a29.938785 29.938785 0 0 0 25.26085 14.033805h2.806761a29.938785 29.938785 0 0 0 25.026953-18.71174l20.816811-78.355414 20.816812 74.145272v2.105071a30.172682 30.172682 0 0 0 52.158976 6.783006l30.406579-56.603015 13.098218 12.864322a29.938785 29.938785 0 0 0 21.050708 8.65418h33.91503a23.389676 23.389676 0 0 0 0.70169-46.779352z' fill='#fff' /><path d='M906.583828 214.249429c-3.976245 16.840566-19.179534 18.01005-33.213339 7.95249-54.731841-39.060758-177.059845-116.948378-283.248972-116.948379-100.809502 0-220.564641 70.169027-280.676108 111.80265a41.633623 41.633623 0 0 1-61.047054-16.60667 41.633623 41.633623 0 0 1 11.694838-50.521699C312.25217 108.761992 439.258109 23.155779 593.396071 23.155779A532.349018 532.349018 0 0 1 905.180448 126.772042c13.332115 9.823664 38.826862 43.97259 35.084513 60.111466z' fill='#fff' /><path d='M1073.118319 605.324806a474.342622 474.342622 0 0 0 3.742348-57.772499A488.610324 488.610324 0 0 0 956.637734 226.178164a70.169027 70.169027 0 0 0-14.267702-82.097762 514.572864 514.572864 0 0 0-713.619004 0 70.169027 70.169027 0 0 0-13.799909 83.033349 487.908634 487.908634 0 0 0-120.456829 320.90635 464.986752 464.986752 0 0 0 3.976244 56.836911 215.418913 215.418913 0 0 0-98.236637 185.246231c0 116.948378 83.735039 210.507081 187.117405 210.507081h14.735496a23.389676 23.389676 0 0 0 23.389675 23.389676h93.558703a23.389676 23.389676 0 0 0 23.389676-23.389676v-421.014161a23.389676 23.389676 0 0 0-23.389676-23.389676h-93.558703a23.389676 23.389676 0 0 0-23.389675 23.389676h-14.501599a167.470078 167.470078 0 0 0-43.972591 6.081315c0-12.396528-1.871174-25.026953-1.871174-37.657377a441.830973 441.830973 0 0 1 107.124715-288.628598 70.169027 70.169027 0 0 0 29.003198 6.315212 68.53175 68.53175 0 0 0 47.948835-19.41343 372.12974 372.12974 0 0 1 520.186386 0 68.53175 68.53175 0 0 0 48.182732 19.41343 70.169027 70.169027 0 0 0 29.237095-6.315212 441.36318 441.36318 0 0 1 107.358611 288.160804c0 12.864322 0 25.494746-1.871174 38.125171a167.470078 167.470078 0 0 0-45.142074-6.549109h-14.501599a23.389676 23.389676 0 0 0-23.389676-23.389676h-93.558702a23.389676 23.389676 0 0 0-23.389676 23.389676v421.014162a23.389676 23.389676 0 0 0 23.389676 23.389675h93.558702a23.389676 23.389676 0 0 0 23.389676-23.389675h14.735496c103.382366 0 187.117405-93.558703 187.117405-210.507081a215.65281 215.65281 0 0 0-98.002741-184.310644z m-821.445409-2.572864h43.97259v374.23481h-43.738693v-374.23481z m-64.321608 23.389675h14.735496v327.455459h-14.501599c-77.419826 0-140.338054-73.443582-140.338054-163.727729s62.684331-163.72773 139.87026-163.72773zM917.576976 197.876656a23.389676 23.389676 0 0 1-10.759251 17.542257 23.389676 23.389676 0 0 1-12.864322 3.742348 21.986295 21.986295 0 0 1-15.437186-6.081316 418.909091 418.909091 0 0 0-584.741891 0 21.986295 21.986295 0 0 1-15.437186 6.081316 23.389676 23.389676 0 0 1-12.864321-3.742348 23.389676 23.389676 0 0 1-10.759251-17.542257 23.389676 23.389676 0 0 1 7.250799-19.881224 467.793513 467.793513 0 0 1 648.829603 0 23.389676 23.389676 0 0 1 6.549109 19.881224z m1.40338 779.110096h-43.738693v-374.23481h43.97259v374.23481z m64.321608-23.389676h-14.501599v-327.455459h14.735496c77.419826 0 140.338054 73.443582 140.338054 163.72773s-63.619918 163.72773-140.805847 163.727729z' fill='#fff' /></svg>
              </div>
              <div>
                <h2 className="text-3xl font-bold tracking-tight text-white">
                {t('newsletterBoxTitle')}
                </h2>
              </div>
            </div>
            <div className='pe-3'>
              <p className="mt-4 max-w-3xl text-lg text-gray-100">
                {t('newsletterBoxContent')}
              </p>
            </div>
          </div>
          <div className="mt-6 md:mt-0 sm:w-full sm:max-w-md md:mt-0 md:me-0 md:flex-1">
            <form method="post" className="md:flex">
              <div className='flex flex-wrap md:pe-5'>
                <div className='w-full pb-3'>
                  <input
                    id="email-address"
                    type="email"
                    autocomplete="email"
                    className="w-full rounded-md border-white p-[15px] placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-700"
                    placeholder={t('newsletterBoxPlaceholder')}
                    onChange={handleChange}
                    value={email}
                  />
                </div>
                <div className='flex'>
                  <div style={{color: "#fff"}}>
                      <input
                      type="checkbox"
                      value={checked}
                      className=""
                      tabIndex="-1"
                      autocomplete="off"
                      required
                      onChange={(e)=>{
                        setChecked(e.target.value)
                      }}
                    />

                  </div>
                  <div id="newsletterPP" className='mb-6 sm:mb-0 ps-2 text-white text-sm'>
                    {t('newsletterBoxConsent')}
                      <Link to={`/${i18n.language}/${t('slugPrivacyPolicy')}`} target="_blank" className='text-sm'>
                        {t('privacyPolicy')}
                      </Link>
                      .
                  </div>
                </div>
              </div>
              <div className='mt-6 md:mt-0'>
              <button
                type="button"
                onClick={sendSubscription}
                className="cta-btn ms-2"
              >
                {t('newsletterBoxCta')}
              </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
